/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './any-type-node.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from './object-node/object-node.component.ngfactory';
import * as i3 from '../../../../app/multi-editor/json-tree/object-node/object-node.component';
import * as i4 from './array-node/array-node.component.ngfactory';
import * as i5 from '../../../../app/multi-editor/json-tree/array-node/array-node.component';
import * as i6 from './primitive-node/primitive-node.component.ngfactory';
import * as i7 from '../../../../app/multi-editor/json-tree/primitive-node/primitive-node.component';
import * as i8 from '@angular/common';
import * as i9 from '../../../../app/multi-editor/json-tree/any-type-node.component';
const styles_AnyTypeNodeComponent:any[] = [i0.styles];
export const RenderType_AnyTypeNodeComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_AnyTypeNodeComponent,data:{}});
function View_AnyTypeNodeComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-object-node',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_ObjectNodeComponent_0,
      i2.RenderType_ObjectNodeComponent)),i1.ɵdid(1,114688,(null as any),0,i3.ObjectNodeComponent,
      ([] as any[]),{value:[0,'value'],diff:[1,'diff'],depth:[2,'depth']},(null as any))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.value;
        const currVal_1:any = _co.diff;
        const currVal_2:any = _co.depth;
        _ck(_v,1,0,currVal_0,currVal_1,currVal_2);
      },(null as any));
}
function View_AnyTypeNodeComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-array-node',
      ([] as any[]),(null as any),(null as any),(null as any),i4.View_ArrayNodeComponent_0,
      i4.RenderType_ArrayNodeComponent)),i1.ɵdid(1,114688,(null as any),0,i5.ArrayNodeComponent,
      ([] as any[]),{value:[0,'value'],diff:[1,'diff'],depth:[2,'depth']},(null as any))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.value;
        const currVal_1:any = _co.diff;
        const currVal_2:any = _co.depth;
        _ck(_v,1,0,currVal_0,currVal_1,currVal_2);
      },(null as any));
}
function View_AnyTypeNodeComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-primitive-node',
      ([] as any[]),(null as any),(null as any),(null as any),i6.View_PrimitiveNodeComponent_0,
      i6.RenderType_PrimitiveNodeComponent)),i1.ɵdid(1,114688,(null as any),0,i7.PrimitiveNodeComponent,
      ([] as any[]),{value:[0,'value'],diff:[1,'diff'],depth:[2,'depth']},(null as any))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.value;
        const currVal_1:any = _co.firstDiff;
        const currVal_2:any = _co.depth;
        _ck(_v,1,0,currVal_0,currVal_1,currVal_2);
      },(null as any));
}
function View_AnyTypeNodeComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),14,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),
      11,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any))),i1.ɵdid(3,16384,(null as any),0,i8.NgSwitch,([] as any[]),{ngSwitch:[0,
      'ngSwitch']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AnyTypeNodeComponent_2)),
      i1.ɵdid(6,278528,(null as any),0,i8.NgSwitchCase,[i1.ViewContainerRef,i1.TemplateRef,
          i8.NgSwitch],{ngSwitchCase:[0,'ngSwitchCase']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n      '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_AnyTypeNodeComponent_3)),i1.ɵdid(9,278528,(null as any),
          0,i8.NgSwitchCase,[i1.ViewContainerRef,i1.TemplateRef,i8.NgSwitch],{ngSwitchCase:[0,
              'ngSwitchCase']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AnyTypeNodeComponent_4)),
      i1.ɵdid(12,278528,(null as any),0,i8.NgSwitchCase,[i1.ViewContainerRef,i1.TemplateRef,
          i8.NgSwitch],{ngSwitchCase:[0,'ngSwitchCase']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n  ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.valueType;
        _ck(_v,3,0,currVal_0);
        const currVal_1:any = 'object';
        _ck(_v,6,0,currVal_1);
        const currVal_2:any = 'array';
        _ck(_v,9,0,currVal_2);
        const currVal_3:any = 'primitive';
        _ck(_v,12,0,currVal_3);
      },(null as any));
}
export function View_AnyTypeNodeComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_AnyTypeNodeComponent_1)),i1.ɵdid(1,16384,(null as any),0,i8.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i9.AnyTypeNodeComponent = _v.component;
    const currVal_0:any = _co.expanded;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_AnyTypeNodeComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-any-type-node',
      ([] as any[]),(null as any),(null as any),(null as any),View_AnyTypeNodeComponent_0,
      RenderType_AnyTypeNodeComponent)),i1.ɵdid(1,114688,(null as any),0,i9.AnyTypeNodeComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AnyTypeNodeComponentNgFactory:i1.ComponentFactory<i9.AnyTypeNodeComponent> = i1.ɵccf('re-any-type-node',
    i9.AnyTypeNodeComponent,View_AnyTypeNodeComponent_Host_0,{value:'value',diff:'diff',
        depth:'depth',expanded:'expanded'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/multi-editor/json-tree/any-type-node.component.ngfactory.ts